const getters = {
  userInfo: state => state.front.userInfo, // userInfo
  announce: state => state.front.announce, // 公告管理
  fundInfo: state => state.front.fundInfo, // 取得基金
  saleFundInfo: state => state.front.saleFundInfo, // 取得基金
  hire: state => state.front.hire, // 招聘人员管理
  catelog: state => state.front.catelog, // 目录管理
  // 圖表
  fundInfoChart: state => state.front.fundInfoChart,
  saleFundInfoChart: state => state.front.saleFundInfoChart,
  // 人員
  fundMemberInfo: state => state.front.fundMemberInfo,
  saleMemberInfo: state => state.front.saleMemberInfo,
  // 公司
  fundCompany: state => state.front.fundCompany,
  saleCompany: state => state.front.saleCompany,
  // 公告
  announceByUser: state => state.front.announceByUser,
  // 海外資產運營第三級
  hotelDetail: state => state.front.hotelDetail,

  // 註冊
  registerData: state => state.front.registerData,
  verifyData: state => state.front.verifyData,
  recover: state => state.front.recover,
  recoverPassword: state => state.front.recoverPassword,
  updatePassword: state => state.front.updatePassword,

  // 會員中心
  userData: state => state.account.userData,
  homeInvest: state => state.account.homeInvest,

  travel: state => state.account.travel,
  travelInfo: state => state.account.travelInfo,
  fundAccounce: state => state.account.fundAccounce,
  homeAccounce: state => state.account.homeAccounce,
  // 上傳圖片
  uploadImg: state => state.account.uploadImg,
}
export default getters
